import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const LoginPage = ({ setUser }) => {
  const navigate = useNavigate();
  const [tab, setTab] = useState('login');
  const [phone, setPhone] = useState('');
  const [code, setCode] = useState('');
  const [codeSent, setCodeSent] = useState(false);
  const [name, setName] = useState('');

  const handleSendCode = () => {
    if (phone.length >= 10) {
      setCodeSent(true);
    }
  };

  const handleLogin = () => {
    setUser({ name: name || '사용자', phone });
    navigate('/');
  };

  return (
    <div style={{ minHeight: '100vh', background: 'white', display: 'flex', flexDirection: 'column' }}>
      {/* 상단 배경 */}
      <div style={{
        background: 'linear-gradient(135deg, #FF6B35 0%, #FF8C5A 100%)',
        padding: '60px 40px 40px', textAlign: 'center'
      }}>
        <div style={{ fontSize: 60, marginBottom: 12 }}>🚐</div>
        <div style={{ color: 'white', fontSize: 28, fontWeight: 800, letterSpacing: '-1px', marginBottom: 6 }}>
          어디용차
        </div>
        <div style={{ color: 'rgba(255,255,255,0.85)', fontSize: 14 }}>
          가는 길에, 믿고 맡기세요
        </div>
      </div>

      <div style={{ padding: '32px 24px' }}>
        {/* 탭 */}
        <div style={{ display: 'flex', background: '#F3F4F6', borderRadius: 12, padding: 4, marginBottom: 24 }}>
          {['login', 'signup'].map(t => (
            <button
              key={t}
              onClick={() => setTab(t)}
              style={{
                flex: 1, padding: '10px', borderRadius: 8, border: 'none',
                background: tab === t ? 'white' : 'transparent',
                color: tab === t ? '#1F2937' : '#9CA3AF',
                fontWeight: 700, fontSize: 14, cursor: 'pointer',
                boxShadow: tab === t ? '0 2px 8px rgba(0,0,0,0.08)' : 'none',
                transition: 'all 0.2s'
              }}
            >
              {t === 'login' ? '로그인' : '회원가입'}
            </button>
          ))}
        </div>

        {tab === 'signup' && (
          <div className="input-group">
            <label className="input-label">이름</label>
            <input className="input-field" value={name} onChange={e => setName(e.target.value)} placeholder="이름을 입력하세요" />
          </div>
        )}

        <div className="input-group">
          <label className="input-label">휴대폰 번호</label>
          <div style={{ display: 'flex', gap: 8 }}>
            <input
              className="input-field"
              value={phone}
              onChange={e => setPhone(e.target.value)}
              placeholder="010-0000-0000"
              style={{ flex: 1 }}
            />
            <button
              onClick={handleSendCode}
              style={{
                background: '#FF6B35', color: 'white', border: 'none',
                borderRadius: 10, padding: '0 16px', fontWeight: 700, cursor: 'pointer', fontSize: 13,
                whiteSpace: 'nowrap'
              }}
            >{codeSent ? '재전송' : '인증번호'}</button>
          </div>
        </div>

        {codeSent && (
          <div className="input-group">
            <label className="input-label">인증번호</label>
            <input
              className="input-field"
              value={code}
              onChange={e => setCode(e.target.value)}
              placeholder="6자리 인증번호"
              maxLength={6}
            />
            <div style={{ fontSize: 12, color: '#9CA3AF', marginTop: 4 }}>
              테스트: 아무 숫자나 입력하세요
            </div>
          </div>
        )}

        <button
          onClick={handleLogin}
          style={{
            width: '100%', padding: '16px', borderRadius: 16,
            background: '#FF6B35', color: 'white', border: 'none',
            fontWeight: 800, fontSize: 16, cursor: 'pointer',
            boxShadow: '0 4px 16px rgba(255,107,53,0.4)', marginBottom: 16
          }}
        >
          {tab === 'login' ? '로그인' : '회원가입'}
        </button>

        {/* 소셜 로그인 */}
        <div style={{ textAlign: 'center', marginBottom: 16 }}>
          <span style={{ fontSize: 13, color: '#9CA3AF' }}>또는 소셜 로그인</span>
        </div>
        <div style={{ display: 'flex', gap: 10, marginBottom: 24 }}>
          {[
            { color: '#FEE500', icon: '💛', label: '카카오' },
            { color: '#03C75A', icon: '💚', label: '네이버' },
            { color: '#E5E7EB', icon: '🍎', label: 'Apple' },
          ].map((social, i) => (
            <button
              key={i}
              onClick={handleLogin}
              style={{
                flex: 1, padding: '12px 0', borderRadius: 12,
                background: social.color, border: 'none', cursor: 'pointer',
                display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2
              }}
            >
              <span style={{ fontSize: 18 }}>{social.icon}</span>
              <span style={{ fontSize: 11, fontWeight: 700 }}>{social.label}</span>
            </button>
          ))}
        </div>

        <button
          onClick={() => navigate('/')}
          style={{ background: 'none', border: 'none', color: '#9CA3AF', fontSize: 13, cursor: 'pointer', width: '100%' }}
        >
          비회원으로 둘러보기 →
        </button>
      </div>
    </div>
  );
};

export default LoginPage;
